import React from 'react';
import { Upload, message,Form } from 'antd';
import { injectIntl } from 'react-intl';
import messages from '../../Containers/ManualSearchV2/ManualSearchMessages';

message.config({
  top: 100,
  duration: 1,
  maxCount: 1,
});

class JobResume extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleUpload = this.handleUpload.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleUpload(e) {
    const { uploadJobResume, jobId, removeJobResume,intl } = this.props;
    if (e.file.status !== 'removed') {
      if (e.file.size / 1024 / 1024 > 1) {
        message.error(intl.formatMessage({ ...messages.fileMustBeSmallerThan1MBLabel }));
      } else if (!['doc', 'docx', 'pdf', 'txt', 'html'].includes(e.file.name.split('.').pop())) {
        message.error(intl.formatMessage({ ...messages.thisFileTypeIsNotSupportedLabel }));
      } else {
        uploadJobResume(jobId, e.file);
      }
    } else {
      removeJobResume(jobId, e.file.uid);
    }
  }

  handleClick(e) {
    const { downloadJobResume, jobId } = this.props;
    downloadJobResume(jobId, e.uid, e.name);
  }

  render() {
    const { resumes, uploadButton, disabled } = this.props;
    return (
      <Upload
        accept=".doc,.docx,.pdf,.html,.txt"
        fileList={resumes}
        beforeUpload={() => false}
        onChange={this.handleUpload}
        onDownload={this.handleClick}
        disabled={disabled}
        showUploadList={{
          showDownloadIcon: true,
          showRemoveIcon: !disabled,
        }}
      >
        {!disabled && resumes.length < 4 ? uploadButton : null}
      </Upload>
    );
  }
}


export default (injectIntl(Form.create()(JobResume)));
